import project from "../assets/image1.jpg";

import project1_main from "../assets/project1_main.jpg";
import project_sub1 from "../assets/project_sub1.jpg";
import project_sub2 from "../assets/project_sub2.jpg";
import project_sub3 from "../assets/project_sub3.jpg";

import project2_main from "../assets/project2_main.jpg";
import project2_sub1 from "../assets/project2_sub1.jpg";
import project2_sub2 from "../assets/project2_sub2.jpg";
import project2_sub3 from "../assets/project2_sub3.png";

import project3_main from "../assets/project3_main.jpg";
// import project3_sub1 from "../assets/image1.jpg"
// import project3_sub2 from "../assets/image1.jpg"

import project4_main from "../assets/project4_main.jpg";
import project4_sub1 from "../assets/project4_sub1.jpg";
import project4_sub2 from "../assets/project4_sub2.jpg";
import project5_main from "../assets/project5_main.jpg";
import project6_main from "../assets/project6_main.jpg";
import project7_main from "../assets/project7_main.jpg";

import journey1 from "../assets/journey1.jpg";
import journey2 from "../assets/journey2.jpg"
import journey3 from "../assets/journey3.jpg"
import journey4 from "../assets/journey4.jpg"

import AB from "../assets/AB.jpg";
import AB1 from "../assets/AB1.jpg";
import AB2 from "../assets/AB2.jpg";
import AB3 from "../assets/AB3.jpg";
import AB4 from "../assets/AB4.jpg";
import AB5 from "../assets/AB5.jpg";

import Studio_1 from "../assets/Studio_1.png";
import Studio_2 from "../assets/Studio_2.png";
import Studio_3 from "../assets/Studio_3.png";
import Studio_4 from "../assets/Studio_4.png";
import Studio_5 from "../assets/Studio_5.png";

import jetairwayslogo from "../assets/Jet-Airways-Logo.jpg";
import hyundailogo from "../assets/Hyundai_logo.jpg";
import bajajlogo from "../assets/bajaj_logo.png"
import R1corp from "../assets/R1corp.jpg"

export const navLinks = [
  {
    id: "home",
    title: "Home",
  },
  {
    id: "companies",
    title: "Companies",
  },
  {
    id: "services",
    title: "Services",
  },
  {
    id: "works",
    title: "Works",
  },
  {
    id: "achievements",
    title: "Achievements",
  },
  {
    id: "clients",
    title: "Clients",
  },
];

const projects = [
  {
    name: "Bungalow",
    location: "Ravet, Pune",
    description: "Laterem House",
    image: project1_main,
    image2: project_sub1,
    image3: project_sub2,
    image4: project_sub3,
  },
  {
    name: "Areia De Goa",
    location: "Arpora, Goa",
    description:
      "Nestled away within a beautifully landscaped setting, a swimming pool, walking tracks and a central green are seven 3-storeyed apartment blocks. Relax in your well-appointed 1BHK and 2 BHK apartments with thoughtful touches to living room, kitchen and bedroom areas embellished with premium fittings and sanitary ware.",
    image: project4_main,
    image2: project4_sub1,
    image3: project4_sub2,
  },
  {
    name: "Celesta",
    location: "Nigdi-Pradhikaran, Pune",
    description: "Apartments and row houses",
    image: project2_main,
    image2: project2_sub1,
    image3: project2_sub2,
    image4: project2_sub3,
  },
  {
    name: "Apartment Complex",
    location: "PCMC",
    description: "",
    image: project3_main,
  },
  {
    name: "Bungalow",
    location: "PCMC",
    description: "",
    image: project5_main,
  },
  {
    name: "Babar Heritage",
    location: "Nigdi-Pradhikaran, Pune",
    description: "Apartment complex",
    image: project6_main,
  },
  {
    name: "Bungalow",
    location: "Pune",
    description: "",
    image: project7_main,
  },
];
const journeys = [
  {
    description:
      "Founded with a vision to create innovative and functional architectural solutions, the company began its journey by delivering thoughtfully designed residential and commercial projects",
    image: journey1,
    date: 2005,
  },
  {
    description:
      "As the portfolio expanded, the company strengthened its reputation through quality-driven execution, modern design practices, and long-term client relationships",
    image: journey2,
    date: 2007,
  },
  {
    description:
      "The studio diversified its expertise by taking on larger-scale projects across residential, commercial, and industrial sectors while focusing on creativity and precision",
    image: journey3,
    date: 2008,
  },
  {
    description:
      "With years of experience and continuous growth, the company evolved into a multidisciplinary design firm known for delivering comprehensive architecture, interior, and planning solutions",
    image: journey4,
    date: 2017,
  },
];
const stats = [
  {
    title: "30+",
    description: "Years of Experience",
  },
  {
    title: "812+",
    description: "Completed Projects",
  },
  {
    title: "80",
    description: "Current Running Projects",
  },
  {
    title: "8580",
    description: "Happy Clients",
  },
  {
    title: "1500+",
    description: "Residential apartments, bungalows , commercial & industrial projects",
  },

];
const Akrutibuildconimages = [
  { image: AB },
  { image: AB1 },
  { image: AB2 },
  { image: AB3 },
  { image: AB4 },
  { image: AB5 },
];
const Studioimages = [
  { image: Studio_1 },
  { image: Studio_2 },
  { image: Studio_3 },
  { image: Studio_4 },
  { image: Studio_5 },
];
const testimonials = [
  {
    name: "Jet Airways",
    designation: "Pune airport lounge",
    image: jetairwayslogo,
  },
  {
    name: "R1 Corp",
    designation: "Consultancy in Uganda & kenya",
    image: R1corp,
  },
  {
    name: "Hyundai",
    designation: "Car showroom",
    image: hyundailogo,
  },
  {
    name: "Bajaj Electricals",
    designation: "Consultancy",
    image: bajajlogo,
  },
];
export {
  projects,
  journeys,
  stats,
  Akrutibuildconimages,
  Studioimages,
  testimonials,
};
